<template>
  <span>
    <b-row class="justify-content-md-center text-center">
      <b-col sm="auto">
        <b-form-group
          label="Année"
          label-class="font-weight-bold"
          label-for="annee"
        >
          <select
            v-model="selectedYear"
            class="form-control"
            name="annee"
            @change="checkDon()"
          >
            <option></option>
            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
          </select>
        </b-form-group>
      </b-col>
    </b-row>
    <span v-if="saisieError.length > 0">
      <p>
        Les saisies suivantes comportent des erreurs, veuillez les modifier
        avant de pouvoir continuer
      </p>
      <custom-tab
        :tableData="saisieError"
        :tableFields="errorTabFields"
      ></custom-tab>
      <b-row class="justify-content-md-center text-center"></b-row>
    </span>
  </span>
</template>
<script>
import ApiService from "../../service/apiService";
import CustomTab from "../CustomTab";

export default {
  props: { value: { type: String, required: false } },
  components: {
    CustomTab: CustomTab,
  },
  data() {
    return {
      years: [],
      selectedYear: "",
      saisieError: [],
      checkedSaisie: false,
      errorTabFields: tableColumns,
    };
  },
  mounted() {
    this.findSaisieYears();
  },
  methods: {
    async findSaisieYears() {
      var response = await ApiService.saisie.findYears();
      this.years = response.data;
    },
    async checkDon() {
      this.checkedSaisie = false;
      if (this.selectedYear) {
        var resp = await ApiService.recuFiscal.checkSaisieDon(
          this.selectedYear
        );
        if (resp.data) {
          for (var saisie of resp.data) {
            var cellVariants = new Object();
            cellVariants.modePaiementLibelle = saisie.modePaiementId
              ? ""
              : "danger";
            cellVariants.adherent = saisie.adherentId ? "" : "danger";
            saisie._cellVariants = cellVariants;
          }
          this.saisieError = resp.data;
          this.checkedSaisie = true;
        }
      } else {
        this.saisieError = [];
      }
    },
  },
  watch: {
    selectedYear(val) {
      this.$emit("input", val);
      this.$emit("change");
    },
  },
};
//Je met ça ici pour épurer l'attribut data
var tableColumns = [
  {
    key: "date",
    label: "Date",
    sortable: true,
  },
  {
    key: "libelle",
    label: "Libelle",
    sortable: true,
  },
  {
    key: "montantEuro",
    label: "Montant (€)",
    sortable: true,
  },

  {
    key: "modePaiementLibelle",
    label: "Mode de paiement",
    sortable: true,
  },
  {
    key: "categorieLibelle",
    label: "Catégorie",
    sortable: true,
  },
  {
    key: "adherent",
    label: "Adhérent",
    sortable: true,
  },
];
</script>
